import Ramp from "../models/Ramp"

const state = {
    exchange_rates: [],
    incoming_currencies: [],
    outgoing_currencies: [],
    exchangeable_currencies: [],
    operator_incoming_currencies: [],
    operator_outgoing_currencies: [],
    operator_exchangeable_currencies: [],
    exchange_rates_loading: false
};

const mutations = {
    'SET_EXCHANGE_RATES'(state, arg) {
        state.exchange_rates = arg.sort((a, b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0))
    },
    'SET_DATETIME'(state, arg) {
        state.exchange_rates['updated_at'] = arg
    },
    'SET_LOADING'(state, arg) {
        state.exchange_rates_loading = arg;
    },
    'SET_EXCHANGEABLE_CURRENCIES'(state, currencies) {
        state.incoming_currencies = currencies.incoming;
        state.outgoing_currencies = currencies.outgoing;
        state.exchangeable_currencies = currencies.all;

        state.operator_incoming_currencies = currencies.operator_incoming;
        state.operator_outgoing_currencies = currencies.operator_outgoing;
        state.operator_exchangeable_currencies = currencies.operator_all;
    }
};

const actions = {
    set_exchange_rates({commit}) {
        try {
            commit('SET_LOADING', true)
            Ramp.exchangeRates(({exchange_rates, update_datetime}) => {
                commit('SET_EXCHANGE_RATES', exchange_rates)
                commit('SET_DATETIME', update_datetime)
                commit('SET_LOADING', false)
            })
        } catch (e) {
            commit('SET_LOADING', false);
            return e;
        }
    },
    set_exchangeable_currencies: ({commit}) => {
        return new Promise((resolve, reject) => {
            Ramp.exchangeable((currencies) => {
                commit('SET_EXCHANGEABLE_CURRENCIES', currencies);
                resolve(currencies)
            }).catch((error) => {
                reject(error)
            })
        })
    }
};

const getters = {
    exchange_rates: state => {
        return state.exchange_rates;
    },
    incoming_currencies: state => {
        return state.incoming_currencies;
    },
    outgoing_currencies: state => {
        return state.outgoing_currencies;
    },
    exchangeable_currencies: state => {
        return state.exchangeable_currencies;
    },
    exchange_rates_loading: state => {
        return state.exchange_rates_loading;
    },
    operator_incoming_currencies: state => {
        return state.operator_incoming_currencies;
    },
    operator_outgoing_currencies: state => {
        return state.operator_outgoing_currencies;
    },
    operator_exchangeable_currencies: state => {
        return state.operator_exchangeable_currencies;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
